export enum CareType {
  Stationary = 'stationary',
  Ambulant = 'ambulant',
  Hospital = 'hospital',
  IntensiveStationary = 'intensive_stationary',
  IntensiveAmbulant = 'intensive_ambulant',
  RehabClinic = 'rehab_clinic',
  Hospice = 'hospice',
  Leasing = 'leasing',
  Others = 'others',
  DentalPractice = 'dental_practice',
  DoctorOffice = 'doctor_office',
  Physiotherapy = 'physiotherapy',
  UniversityHospital = 'university_hospital',
  PrivateClinic = 'private_clinic',
  MedicalCareCenter = 'medical_care_center',
  OutpatientPractice = 'outpatient_practice',
}

export enum IntensiveCareType {
  Wg = 'WG',
  OneToOne = '1 to 1',
}

export const PRAXIA_CARE_TYPES = [CareType.DentalPractice, CareType.DoctorOffice, CareType.Physiotherapy];

export const DOCIA_ONLY_CARE_TYPES = [
  CareType.UniversityHospital,
  CareType.PrivateClinic,
  CareType.MedicalCareCenter,
  CareType.OutpatientPractice,
];

export const DOCIA_CARE_TYPES = [CareType.Hospital, CareType.DentalPractice, CareType.RehabClinic, ...DOCIA_ONLY_CARE_TYPES];

export const TRANSLATED_CARE_TYPES = {
  [CareType.Stationary]: 'Stationär',
  [CareType.Ambulant]: 'Ambulant',
  [CareType.Hospital]: 'Krankenhaus',
  [CareType.RehabClinic]: 'Rehaklinik',
  [CareType.Hospice]: 'Hospiz',
  [CareType.IntensiveStationary]: 'Intensiv (Stationär)',
  [CareType.IntensiveAmbulant]: 'Intensiv (Ambulant)',
  [CareType.Leasing]: 'Leasing',
  [CareType.DentalPractice]: 'Zahnarztpraxis',
  [CareType.DoctorOffice]: 'Praxis/MVZ',
  [CareType.Others]: 'Sonstiges',
  [CareType.Physiotherapy]: 'Physiotherapie',
  [CareType.UniversityHospital]: 'Universitätsklinikum',
  [CareType.PrivateClinic]: 'Privatklinik',
  [CareType.MedicalCareCenter]: 'MVZ',
  [CareType.OutpatientPractice]: 'Praxis (ambulant)',
};
